// extracted by mini-css-extract-plugin
export default {"obstacles":"Obstacles_obstacles__1e75b"};